import Styled from "styled-components";

export const Label = Styled.p`
  margin: 0;
  color: ${props => props.theme?.whitelabel?.theme?.text_primary_color || props.color};
`;

export const HeaderLabel = Styled.p`
  margin: 0;
  color: ${props => props.theme?.whitelabel?.theme?.text_primary_color || props.color};
`;

export const ContainerLabel = Styled.div`
  display:flex;
  flex-direction: column;
`;

export const Card = Styled.div`
  display:flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = Styled.p`
  color: ${props => props.theme?.whitelabel?.theme?.text_primary_color || props.color};
`;

export const CreditCardButton = Styled.button`
  width: 100%;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: transparent;
  color: ${props => props.theme?.whitelabel?.theme?.text_primary_color || props.color};
  
  svg {
    color: ${props => props.theme?.whitelabel?.theme?.text_primary_color || props.color};
  }
`;
